export default __webpack_public_path__ + "static/media/Path2261.f9e511c4.svg";